import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iqac-code-of-conduct',
  templateUrl: './iqac-code-of-conduct.component.html',
  styleUrls: ['./iqac-code-of-conduct.component.scss']
})
export class IqacCodeOfConductComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
